module.exports = __webpack_public_path__ + "static/media/img-small-2.2f989759.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/img-small-2.png
// module id = 71
// module chunks = 0